var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 4.5V8a1 1 0 0 1-2 0V4.5c0-.449-.052-.5-.5-.5H16a1 1 0 0 1 0-2h3.5A2.32 2.32 0 0 1 22 4.5zM8 2H4.5A2.32 2.32 0 0 0 2 4.5V8a1 1 0 0 0 2 0V4.5c0-.449.052-.5.5-.5H8a1 1 0 0 0 0-2zm0 18H4.5c-.448 0-.5-.051-.5-.5V16a1 1 0 0 0-2 0v3.5A2.32 2.32 0 0 0 4.5 22H8a1 1 0 0 0 0-2zm13-5a1 1 0 0 0-1 1v3.5c0 .449-.052.5-.5.5H16a1 1 0 0 0 0 2h3.5a2.32 2.32 0 0 0 2.5-2.5V16a1 1 0 0 0-1-1z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.542a3cc476032aafa77d1dfb737a7dc7.svg";
export { ForwardRef as ReactComponent };